import React from "react";
import { Route, Switch } from "react-router-dom";
import { OptVerification } from "../../components/OptVerification";
// Guest (unauthenticated, invoiceId-linked) flow — out of scope for the v3
// person-session migration. Disabled, not deleted: see
// CLIENT_PAYMENTS_PERSON_FLOW_PLAN.md decision 2.
// import { ClientSignInModal } from "./components/ClientSignInModal/ClientSignInModal";
// import { ClientPaymentsInvoiceDetails } from "./routes/ClientPaymentsInvoiceDetails";
// import { ClientPaymentsInvoicePaymentACH } from "./routes/ClientPaymentsInvoicePaymentACH";
// import { ClientPaymentsInvoicePaymentManual } from "./routes/ClientPaymentsInvoicePaymentManual";
// import { ClientPaymentsInvoicePaymentSuccess } from "./routes/ClientPaymentsInvoicePaymentSuccess";
// import { ClientPaymentsInvoicePaymentType } from "./routes/ClientPaymentsInvoicePaymentType";
import { ProtectedRoutes } from "./routes/protected";
// import { RouteCreditCard } from "./routes/RouteCreditCard";
// import { RoutePasswordReset } from "./routes/RoutePasswordReset";

export const PaymentApp: React.FC = () => {
  return (
    <>
      {/* <ClientSignInModal /> */}
      <OptVerification />
      <Switch>
        <Route
          path={[
            "/payment/history",
            "/payment/account",
            "/payment/add-bank-account-manually",
            "/payment/manage-payment-method",
            "/payment/add-payment-method"
          ]}
          component={ProtectedRoutes}
        />
        {/*
          Guest (unauthenticated, invoiceId-linked) flow — out of scope for
          the v3 person-session migration. Disabled, not deleted: see
          CLIENT_PAYMENTS_PERSON_FLOW_PLAN.md decision 2.

        <Route
          exact
          path="/payment/reset-password"
          component={RoutePasswordReset}
        />
        <Route
          exact
          path="/payment/:invoiceId"
          component={ClientPaymentsInvoiceDetails}
        />
        <Route
          exact
          path="/payment/:invoiceId/2"
          component={ClientPaymentsInvoicePaymentType}
        />
        <Redirect
          exact
          path="/payment/:invoiceId/3"
          to="/payment/:invoiceId/2"
        />
        <Route
          exact
          path="/payment/:invoiceId/3/ach"
          component={ClientPaymentsInvoicePaymentACH}
        />
        <Route
          exact
          path="/payment/:invoiceId/3/creditCard"
          component={RouteCreditCard}
        />
        <Route
          exact
          path="/payment/:invoiceId/3/manual"
          component={ClientPaymentsInvoicePaymentManual}
        />
        <Route
          exact
          path="/payment/:invoiceId/success"
          component={ClientPaymentsInvoicePaymentSuccess}
        />
        */}
      </Switch>
    </>
  );
};
